import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  fluid: "",
  style: {"display":"inline-grid","justify-content":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_TemplateEditor = _resolveComponent("TemplateEditor")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_SuccessAlert = _resolveComponent("SuccessAlert")!
  const _component_SingleErrorMessage = _resolveComponent("SingleErrorMessage")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              size: 70,
              width: 7,
              color: "loading",
              indeterminate: ""
            })
          ]))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            tyle: "padding-bottom: 20px;"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Select Template ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    align: "center",
                    fluid: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "9"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, _mergeProps({
                            modelValue: _ctx.selectedTemplate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
                            clearable: "",
                            items: _ctx.templates,
                            "item-title": "label"
                          }, {'return-object':true}), null, 16, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      (_ctx.canCreateNewTemplates)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                class: "mx-2 mb-4",
                                color: "secondary",
                                disabled: _ctx.isSaving,
                                onClick: _ctx.newTemplate
                              }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                  _createTextVNode("New Template", -1)
                                ]))]),
                                _: 1
                              }, 8, ["disabled", "onClick"])), [
                                [_directive_ripple]
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (_ctx.selectedTemplate != null)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 2,
            align: "center",
            style: {"padding":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TemplateEditor, {
                activeTemplate: _ctx.selectedTemplate,
                onOnChange: _ctx.onChange
              }, null, 8, ["activeTemplate", "onOnChange"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.selectedTemplate != null)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 3,
            align: "center",
            style: {"padding":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                          class: "mx-2 mb-4",
                          color: "success",
                          disabled: !_ctx.selectedTemplate || _ctx.selectedTemplate.label == '' || _ctx.isSaving || _ctx.isDeleting,
                          onClick: _ctx.submit
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Save", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "onClick"])), [
                          [_directive_ripple]
                        ])
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "Ensure the template has a label before saving.", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { md: "2" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                    class: "mx-2 mb-4",
                    color: "failure",
                    disabled: _ctx.isSaving || _ctx.isDeleting,
                    onClick: _ctx.deleteTemplate
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Delete", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])), [
                    [_directive_ripple]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSaving || _ctx.isDeleting)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_LoadingSpinner),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_SuccessAlert, { feedbackMessages: _ctx.successMessages }, null, 8, ["feedbackMessages"]),
          (_ctx.errorMessage != '')
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SingleErrorMessage, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.validationResults.length != 0)
            ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ValidationAlert, { validationResults: _ctx.validationResults }, null, 8, ["validationResults"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}